document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        function snizeRenderReviews() {
            setTimeout(function() {
                $(".snize-product:not('.snize-review-checked')").each(function() {
                    $(this).addClass('snize-review-checked');
                    let productData = $(this).data('snize_item_data');
                    let productEl = $(this);
                    let snizeReviewsRating = productData.metafield_afb9677bf3c4d4aba40fd78e7154a8c7.split(' ')[2];
                    let snizeReviewsCount = productData.metafield_0c06c6c2e1ed467ffa8c207f15b12c9e;
                    let snizeStarPercentage = (parseFloat(snizeReviewsRating) / 10) * 200;
                    let snizeStarHtml = `<span class="snize-reviews"><span class="stars-container stars-${snizeStarPercentage}">★★★★★</span><span class="total-reviews">${snizeReviewsCount} review(s)</span></span>`;
                    if (!$('.snize-reviews', productEl).length && snizeReviewsCount !== '0') {
                        if ($('.snize-overhidden', productEl).length) {
                            $('.snize-overhidden', productEl).append(snizeStarHtml);
                        } else {
                            $('.snize-item', productEl).append(snizeStarHtml);
                        }
                    }
                });
            }, 100);
        }

        $(document).on('Searchanise.ResultsUpdated', snizeRenderReviews);
        $(document).on('Searchanise.AutocompleteUpdated', snizeRenderReviews);
        $(document).on('Searchanise.RecommendationUpdated', snizeRenderReviews);
    })(window.Searchanise.$);
});